export default __webpack_public_path__ + "static/media/modeIconLight.ca5e1ae2.svg";